import { z } from 'zod';
import { BaseApplicationDTOSchema, } from "./applications.dto.js";
export const FindApplicationByIdRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseApplicationDTOSchema.shape.companyId,
        facilityId: BaseApplicationDTOSchema.shape.facilityId,
        applicationId: BaseApplicationDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=find-application-by-id.dto.js.map